import { toast } from "react-toastify";
import { toastProperties } from "./Toaster";

export const ErrorMessage = (message) => {
  toast.error(message, toastProperties);
};

export const SuccessMessage = (message) => {
  toast.success(message, toastProperties);
};
